module.exports = __webpack_public_path__ + "img/security.ffd14950.svg";